import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GameType } from '@app/@shared/models/game.model';
import { TrisTicket } from '@app/@shared/models/tris.model';
import { TrisService } from '@app/@shared/services/tris.service';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-numbers',
  templateUrl: './numbers.component.html',
  styleUrl: './numbers.component.scss',
})
export class NumbersComponent implements OnInit {
  @Input() size = 0;
  @Input() limit = 0;
  @Input() values: number[] = [];
  @Input() gameType?: GameType;
  @Input() isRetro = false;
  @Input() trisType: boolean[] = [];
  @Input() trisS?: TrisService;
  @Input() trisTicket?: TrisTicket;

  @Output() valueChange = new EventEmitter<number[]>();

  tens = [0, 10, 20, 30, 40, 50];

  constructor(private alertCtrl: AlertController, private translateS: TranslateService) {}

  ngOnInit(): void {
    if (this.gameType === 'tris') {
      this.tens = [0, 0, 0, 0, 0];
    } else this.tens = this.tens.filter((t) => t < this.limit);
  }

  /**
   *
   * @param i no de fila en la matris de numeros comenzando desde 0
   * @param j
   * @param k no de columna en la matriz de numeros comenzando desde 0
   */
  select(i: number, j: number, k: number) {
    if (this.isDisabled(i, j, k)) {
      if (this.gameType === 'tris' && this.trisTicket && this.trisS) {
        this.trisS.showMesageError(this.trisTicket, k);
      }
    } else {
      if (this.gameType === 'tris') {
        if (this.values[k] === i) {
          // this.values[k] = -1;
        } else {
          this.values[k] = i;
        }
        if (this.trisS && this.trisTicket) {
          //console.log(this.trisS.isTicketValid({ ...this.trisTicket,value: this.values,}));
        }
      } else {
        const n = i + j + 1;
        if (this.values.find((v) => v === n)) {
          this.values = this.values.filter((v) => v !== n);
        } else if (this.values.length < this.size) {
          this.values.push(n);
          this.values = this.values.sort((a, b) => a - b);
        }
      }
      this.valueChange.emit(this.values);
    }
  }

  isSelected(i: number, j: number, k: number): boolean {
    if (this.gameType === 'tris') {
      return this.values[k] === i;
    } else {
      const n = i + j + 1;
      return !!this.values.find((v) => v === n);
    }
  }

  isDisabled(i: number, j: number, k: number) {
    if (this.gameType === 'tris') {
      if (this.trisType[k]) {
        if (this.trisS && this.trisTicket?.price.combo) {
          const repeats = [...this.trisTicket.price.combo.requiredRepeat].sort((a, b) => b - a);
          if (repeats.length > 0 && !this.isSelected(i, j, k)) {
            const value = this.trisTicket.value;
            let toDisable = false;
            for (let l = 0; l < repeats.length; l++) {
              if (!toDisable && repeats[l] > 0) {
                const n = i + j;
                if (
                  value.filter((v) => v === n).length === repeats[l] &&
                  repeats.filter((r) => r > repeats[l]).length === 0
                ) {
                  toDisable = true;
                  repeats[l] = 0;
                }
              }
            }
            return toDisable;
          }
        }
      }
      return !this.trisType[k];
    }
    return false;
  }
}
